import React from "react";
import Translate from "react-translate-component";

export var FileWrite = function FileWrite() {
    return React.createElement(
        "span",
        null,
        React.createElement(Translate, { component: "span", content: "proposal.file_write" })
    );
};